import { makeStyles } from '@material-ui/core';
import useIsCompany from '../../myHooks/useIsCompany';
import UserDropdown from '../../myComponents/userDropdown';
import ClientsBubble from '../../myComponents/ClientsBubble';

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: '100%',
    padding: '12px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: 30,

    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
}));

const UserDropdownHeader = ({ bgColor = '#F9F9F9' }) => {
  const classes = useStyles();
  const isCompany = useIsCompany();
  return (
    <div className={classes.wrapper} style={{ background: bgColor }}>
      {isCompany && <ClientsBubble />}
      <UserDropdown />
    </div>
  );
};

export default UserDropdownHeader;
